import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2, GraduationCap, AlertTriangle } from 'lucide-react';

const GRADE_COLOR = { A: 'bg-green-100 text-green-800', B: 'bg-emerald-100 text-emerald-800', C: 'bg-amber-100 text-amber-800', D: 'bg-orange-100 text-orange-800', E: 'bg-red-100 text-red-800' };

export default function ParentReportPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`/api/report-links/${token}`).then(async (r) => {
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || 'Error');
      setData(d);
    }).catch((e) => setError(e.message));
  }, [token]);

  if (error) return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="text-center" data-testid="report-link-error">
        <AlertTriangle className="w-12 h-12 mx-auto text-amber-500 mb-3" />
        <p className="font-semibold text-gray-700">Sori, link ia i no wok</p>
        <p className="text-sm text-gray-500 mt-1">{error}</p>
        <p className="text-sm text-gray-500 mt-2">Plis askem skul blong givim yu wan niu link.</p>
      </div>
    </div>
  );
  if (!data) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin text-blue-600" /></div>;

  return (
    <div className="min-h-screen bg-slate-100 pb-10" data-testid="parent-report-page">
      <div className="bg-blue-900 text-white p-5 text-center">
        <GraduationCap className="w-9 h-9 mx-auto mb-1" />
        <h1 className="text-lg font-bold">{data.school_name}</h1>
        <p className="text-blue-200 text-sm">Ripot Kad blong Pikinini — {data.term} 2026</p>
      </div>

      <div className="max-w-md mx-auto px-4 -mt-0">
        <div className="bg-white rounded-b-xl shadow p-5 text-center">
          <div className="text-xl font-bold" data-testid="report-student-name">{data.student_name}</div>
          <div className="mt-3 flex items-center justify-center gap-3">
            <div>
              <div className="text-3xl font-bold text-blue-900">{data.overall_pct}%</div>
              <div className="text-xs text-gray-500">Ova-ol Mak (Overall)</div>
            </div>
            <span className={`text-2xl font-bold px-4 py-2 rounded-xl ${GRADE_COLOR[data.overall_grade]}`}>{data.overall_grade}</span>
          </div>
        </div>

        <h2 className="text-sm font-semibold text-gray-500 uppercase mt-6 mb-2 px-1">Ol Sabjek (Subjects)</h2>
        <div className="space-y-3">
          {data.subjects.map((s) => (
            <div key={s.subject} className="bg-white rounded-xl shadow p-4" data-testid={`subject-card-${s.subject}`}>
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-semibold">{s.subject}</div>
                  {s.teacher && <div className="text-xs text-gray-400">Tija: {s.teacher}</div>}
                </div>
                <div className="flex items-center gap-2">
                  <span className="text-lg font-bold text-blue-900">{s.final_pct}%</span>
                  <span className={`text-sm font-bold px-2.5 py-1 rounded-lg ${GRADE_COLOR[s.grade]}`}>{s.grade}</span>
                </div>
              </div>
              <div className="mt-2 border-t pt-2 space-y-1">
                {s.components.map((c, i) => (
                  <div key={i} className="flex justify-between text-sm text-gray-600">
                    <span>{c.title}</span>
                    <span>{c.raw}/{c.max} <span className="text-gray-400">({c.pct}%)</span></span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        {data.subjects.length === 0 && (
          <div className="bg-white rounded-xl shadow p-6 text-center text-gray-500 text-sm">No mak i stap yet blong {data.term}.</div>
        )}
        <p className="text-center text-xs text-gray-400 mt-6">Sipos yu gat kwestin, plis toktok wetem tija blong pikinini. Tank yu tumas!</p>
      </div>
    </div>
  );
}
